import request from "@/axios.js";

export class ProvidersServices {
	/**
	 * UserService class
	 * @property {number} provider_id - ID of a provider.
	 * @property {number} service_id - ID of a service
	 */
	constructor(providersServices) {
		this.provider_id = providersServices.provider_id;
		this.service_id = providersServices.service_id;
	}

	/**
	 * Create a ProvidersServices
	 * @param {ProvidersServices} ProvidersServices - ProvidersServices to create
	 */
	createProvidersService(callback) {
		let param = {
			provider_id: this.provider_id,
			service_id: this.service_id,
		};
		request
			.post("providersServices/add", param)
			.then(result => {
				callback(null, result);
			})
			.catch(err => callback(err, null));
	}

	/**
	 * Create all UserService from a list of ProvidersServices
	 * @param {Array} providersServices - list of ProvidersServices Objects
	 * @param {function} callback
	 */
	/*
	 * static createUserServicesFromList(userServices, callback){
	 *   //console.log("createUserServicesFromList BEGIN")
	 *   //console.log("userServices")
	 *   //console.log(userServices)
	 *   for(let userService in userServices){
	 *     //console.log("userService")
	 *     //console.log(userService)
	 *     userService.createProvidersService((err, res) => {
	 *       if(err) //console.log(err)
	 *       if(res) //console.log(res)
	 *     })
	 *   }
	 *   //console.log("createUserServicesFromList END")
	 * }
	 */

	compare(providersServiceToCompare){
		for(let key in providersServiceToCompare) {
			if(this[key] != providersServiceToCompare[key]){
				return false;
			}
		}
		return true;
	}

	/**
	 * Get services from user id
	 */
	static getServiceFromProvider(provider_id, callback){
		let services_list = [];
		request
			.get("providersServices/getsu/" + provider_id)
			.then(result => {
				callback(null, result);
			})
			.catch(err => {
				callback(err, null);
			});
		return services_list;
	}

	/**
	 * Delete service for provider id
	 */
	static deleteServiceForProvider(provider_id, service_id, callback){
		//console.log(provider_id);
		//console.log(service_id);

		request
			.delete("providersServices/delete/" + provider_id + "/" + service_id)
			.then(result => {
				callback(null, result);
			})
			.catch(err => {
				callback(err, null);
			});
	}
}
